function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Big = require('big.js');
var _ = require('lodash');
/*
 * Tax configuration is stored in a list of objects which look like
 * - name         string
 * - taxType      sales|cannabis
 * - rate         float percentage
 * - potency      string
 * - potencyRate  float percentage
 * - medical      boolean
 * - recreational boolean
 * - applyTo: {
 * -  types: [Flower|Edibles|....]
 * -  hemp: boolean (currently not supported in admin/integrations)
 * - }
 * - stages [
 * -  {type: pos|menu|checkout, op: add/subtract/noop}
 * -  ...
 * - ]
 * - deliveryPolicy originBased|destinationBased (sales tax only)
 */ var operandMap = {
    lessThan: function(a, b) {
        return a < b;
    },
    lessThanEqualTo: function(a, b) {
        return a <= b;
    },
    equalTo: function(a, b) {
        return a === b;
    },
    greaterThan: function(a, b) {
        return a > b;
    },
    greaterThanEqualTo: function(a, b) {
        return a >= b;
    },
    notApplicable: function() {
        return true;
    }
};
var roundTo = function(value, digits) {
    return Math.round(value * Math.pow(10, digits)) / Math.pow(10, digits);
};
// Takes rules which have sub-structure and flattes them out.
var flattenTaxes = function(taxData) {
    var rv = [];
    _.forEach(taxData.taxes, function(tax) {
        _.forEach(tax.stages, function(stage) {
            var f = _object_spread_props(_object_spread({}, tax), {
                taxType: tax.type,
                taxBasis: tax.taxBasis,
                stage: stage
            });
            delete f.stages;
            rv.push(f);
        });
    });
    return rv;
};
// Filter for a set of taxes.
var relevantTaxRules = function(category, hemp, type, taxRules, stage) {
    return _.filter(taxRules, function(rule) {
        var catValue = hemp ? rule.hemp : !rule.applyTo || rule.applyTo.types && rule.applyTo.types.includes(category);
        return (type === 'med' ? rule.medical : rule.recreational) && catValue && (!stage || rule.stage.type === stage);
    });
};
var sumTaxesAtLayer = function(flattenedRules, item) {
    return _.reduce(flattenedRules, function(accum, rule) {
        var _rule_stage;
        var value = rule.rate;
        if (rule.type === 'bottleDeposit') {
            value = item.product.bottleDepositTaxCents || 0;
        }
        switch((_rule_stage = rule.stage) === null || _rule_stage === void 0 ? void 0 : _rule_stage.op){
            case 'add':
                accum = accum.plus(value);
                break;
            case 'subtract':
                accum = accum.minus(value);
                break;
            default:
                break;
        }
        return accum;
    }, Big(0));
};
var calcTaxesAtLayer = function(param) {
    var category = param.category, hemp = param.hemp, type = param.type, taxRules = param.taxRules, stage = param.stage, thcContent = param.thcContent, isDelivery = param.isDelivery, product = param.product, _option = param._option;
    var taxes = {
        sales: Big(0),
        cannabis: Big(0),
        bottleDeposit: Big(0)
    };
    var rules = relevantTaxRules(category, hemp, type, taxRules, stage);
    _.forEach(Object.keys(taxes), function(taxType) {
        var value = Big(0);
        _.forEach(_.filter(rules, function(rule) {
            return rule.taxType === taxType;
        }), function(rule) {
            var potency = rule.potency, potencyRate = rule.potencyRate, rate = rule.rate, destinationRate = rule.destinationRate;
            // apply destination-based sales tax, if applicable
            var baseValue = isDelivery && _.isFinite(destinationRate) ? destinationRate : rate;
            if (taxType === 'bottleDeposit') {
                baseValue = Big(product.bottleDepositTaxCents || 0);
            }
            // if we have potency & thcContent, but the operand formed is false, do not include
            // that rule's rate in the total tax rate.
            var thcValueDoesntMatchRule = potency && thcContent && !operandMap[potency](thcContent, potencyRate * 100);
            // if we have potency but no thcContent, then exclude all but rules with 'greater', 'less', or 'notApplicable'
            var noThc = potency && !thcContent;
            var largestPotencyRule = _.includes(potency, 'greater');
            var lesserPotencyRule = _.includes(potency, 'less');
            var ignorePotency = _.includes(potency, 'notApplicable');
            switch(rule.stage.op){
                case 'noop':
                    break;
                case 'add':
                    if (thcValueDoesntMatchRule || noThc && largestPotencyRule && !lesserPotencyRule && !ignorePotency) {
                        baseValue = Big(0);
                    }
                    // if we do not have potency or thcContent, or we do and the operand perfomed is true,
                    // include that rule's rate in the total tax rate.
                    value = value.plus(baseValue);
                    break;
                case 'subtract':
                    if (thcValueDoesntMatchRule || noThc && largestPotencyRule && !lesserPotencyRule && !ignorePotency) {
                        baseValue = Big(0);
                    }
                    // if we do not have potency or thcContent, or we do and the operand perfomed is true,
                    // subtract that rule's rate from the total tax rate.
                    value = value.minus(baseValue);
                    break;
                default:
                    throw new Error("improper tax configuration op ".concat(rule.stage.op));
            }
        });
        taxes[taxType] = taxes[taxType].add(value);
    });
    return taxes;
};
var layerOrder = [
    'base',
    'pos',
    'menu',
    'checkout'
];
/*
 * When calculating to layer we assume you start with the taxes at layer n - 1.
 *
 * We call the n-1 layer the Previous (pre) layer.
 * Nominally in order to do taxes at layer N we need to undo what was done at
 * the previous layer and redo them at this layer.  With a positive tax you undo
 * by dividing and do by multiplying.  Reverse that for a negative tax.
 *
 * initialStage lets you go back more then one stage.  If not null it defines the
 * stage to start at by name.
 *
 * We allow for taxes to be based off of a number that comes from the POS (that might include
 * taxes) or for cannabis taxes to be based off the wholesale price.  We wrap this logic and
 * configuration up in the closures we return to the caller.
 */ var calcTaxes = function(param) {
    var category = param.category, hemp = param.hemp, thcContent = param.thcContent, type = param.type, taxRules = param.taxRules, taxMethod = param.taxMethod, stage = param.stage, _param_initialStage = param.initialStage, initialStage = _param_initialStage === void 0 ? null : _param_initialStage, _param_isDelivery = param.isDelivery, isDelivery = _param_isDelivery === void 0 ? false : _param_isDelivery, _param_product = param.product, product = _param_product === void 0 ? {} : _param_product, option = param.option;
    if (stage === 'base') {
        throw new Error('stage should be pos or higher');
    }
    var returnZero = function() {
        return 0;
    };
    if (stage === initialStage) {
        return {
            cannabisTax: returnZero,
            salesTax: returnZero,
            taxMult: 1.0
        };
    }
    var retailTaxRules = _.filter(taxRules, function(rule) {
        return rule.taxBasis !== 'wholesale';
    });
    var wholesaleTaxRules = _.filter(taxRules, function(rule) {
        return rule.taxBasis === 'wholesale';
    });
    var stageIndex = _.findIndex(layerOrder, function(s) {
        return s === stage;
    });
    var startStageIndex;
    if (!initialStage) {
        startStageIndex = stageIndex - 1;
    } else {
        startStageIndex = _.findIndex(layerOrder, function(s) {
            return s === initialStage;
        });
    }
    var stageTaxes = [];
    _.forEach(layerOrder.slice(1, stageIndex + 1), function(stageName) {
        stageTaxes.push(calcTaxesAtLayer({
            category: category,
            hemp: hemp,
            type: type,
            taxRules: retailTaxRules,
            stage: stageName,
            thcContent: thcContent,
            isDelivery: isDelivery,
            product: product,
            option: option
        }));
    });
    var wholesaleStageTaxes = [];
    _.forEach(layerOrder.slice(1, stageIndex + 1), function(stageName) {
        wholesaleStageTaxes.push(calcTaxesAtLayer({
            category: category,
            hemp: hemp,
            type: type,
            taxRules: wholesaleTaxRules,
            stage: stageName,
            thcContent: thcContent,
            isDelivery: isDelivery,
            product: product,
            option: option
        }));
    });
    var upTo = stageTaxes.slice(0, startStageIndex);
    var salesPreRate = Big(0), cannabisPreRate = Big(0), bottleDepositPreSum = Big(0);
    cannabisPreRate = _.reduce(upTo, function(accum, tax) {
        return accum.add(tax.cannabis);
    }, cannabisPreRate);
    salesPreRate = _.reduce(upTo, function(accum, tax) {
        return accum.add(tax.sales);
    }, salesPreRate);
    bottleDepositPreSum = _.reduce(upTo, function(accum, tax) {
        return accum.add(tax.bottleDeposit);
    }, bottleDepositPreSum);
    var cannabisRate = _.reduce(stageTaxes, function(accum, tax) {
        return accum.add(tax.cannabis);
    }, Big(0));
    var salesRate = _.reduce(stageTaxes, function(accum, tax) {
        return accum.add(tax.sales);
    }, Big(0));
    var bottleDepositRate = _.reduce(stageTaxes, function(accum, tax) {
        return accum.add(tax.bottleDeposit);
    }, Big(0));
    var wholesaleCannabisTaxRate = _.reduce(wholesaleStageTaxes, function(accum, tax) {
        return accum.add(tax.cannabis);
    }, Big(0));
    var undo, apply;
    if (taxMethod === 'compound') {
        undo = Big(1);
        if (salesPreRate.lt(0)) {
            undo = undo.div(salesPreRate.times(-1).plus(1));
        } else if (salesPreRate.gt(0)) {
            undo = undo.times(salesPreRate.plus(1));
        }
        if (cannabisPreRate.lt(0)) {
            undo = undo.div(cannabisPreRate.times(-1).plus(1));
        } else if (cannabisPreRate.gt(0)) {
            undo = undo.times(cannabisPreRate.plus(1));
        }
        apply = Big(1);
        if (salesRate.lt(0)) {
            apply = apply.div(salesRate.times(-1).plus(1));
        } else if (salesRate.gt(0)) {
            apply = apply.times(salesRate.plus(1));
        }
        if (cannabisRate.lt(0)) {
            apply = apply.div(cannabisRate.times(-1).plus(1));
        } else if (cannabisRate.gt(0)) {
            apply = apply.times(cannabisRate.plus(1));
        }
    } else {
        undo = Big(1);
        undo = undo.plus(salesPreRate);
        undo = undo.plus(cannabisPreRate);
        apply = Big(1);
        apply = apply.plus(salesRate);
        apply = apply.plus(cannabisRate);
    }
    // bottle deposit tax is non-componding, therefore tax method is irrelevant
    var bottleDepositTaxCents = bottleDepositRate.minus(bottleDepositPreSum);
    var taxMult = apply.div(undo);
    var isOrdered = taxMethod !== 'cumulative' && retailTaxRules.filter(function(rule) {
        return rule.stage.op !== 'noop' && !_.isNil(rule.order);
    }).length > 0;
    var orderedRules;
    if (isOrdered) {
        orderedRules = relevantTaxRules(category, hemp, type, retailTaxRules, null).filter(function(rule) {
            return rule.stage.op !== 'noop';
        }).sort(function(ruleA, ruleB) {
            return ruleA.order - ruleB.order;
        });
    }
    var orderedTaxesMult = function(rules, taxType, lastTotalInit) {
        var taxValue = Big(lastTotalInit || 1);
        var layers = layerOrder.slice(startStageIndex + 1, stageIndex + 1);
        _.forEach(rules, function(rule) {
            if ((!taxType || rule.type === taxType) && layers.includes(rule.stage.type)) {
                var taxRate = rule.rate;
                // Mirror the potency-tier filtering makeCalcTax's ordered branch already applies: an ordered
                // potency-tiered tax rule (e.g. IL excise "High"/"Low" THC tiers) should only contribute to the
                // multiplier when the product's thcContent actually satisfies that rule's potency comparison.
                // Without this, the menu display multiplier bakes in every potency tier's rate regardless of the
                // item's actual THC%, inflating the displayed price above what's actually charged at checkout.
                var potency = rule.potency, potencyRate = rule.potencyRate;
                var thcValueDoesntMatchRule = potency && thcContent && !operandMap[potency](thcContent, potencyRate * 100);
                var noThc = potency && !thcContent;
                var largestPotencyRule = _.includes(potency, 'greater');
                if (thcValueDoesntMatchRule || noThc && !largestPotencyRule) {
                    taxRate = 0;
                }
                taxValue = rule.stage.op === 'add' ? taxValue.times(Big(1).plus(taxRate)) : taxValue.div(Big(1).plus(taxRate));
            }
        });
        return taxValue;
    };
    var makeTaxOp = function(taxMeth) {
        return taxMeth === 'compound' ? function(a, b) {
            return (1 + a) * (1 + b);
        } : function(a, b) {
            return 1 + a + b;
        };
    };
    var taxOp = makeTaxOp(taxMethod);
    var basePriceCalc = function(spRate, cpRate, bdSum) {
        return function(price) {
            return (price - bdSum / 100) / taxOp(Number(spRate), Number(cpRate));
        };
    };
    var makeCalcTax = function(otherTax, tax, taxType) {
        return function(price, wPrice, productData) {
            var base = price / taxOp(Number(salesPreRate), Number(cannabisPreRate));
            wPrice = _.isNil(wPrice) ? Big(0) : Big(wPrice);
            if (taxMethod === 'cumulative') {
                if (!isOrdered) {
                    if (taxType === 'cannabis') {
                        return tax.times(base).add(wPrice.times(wholesaleCannabisTaxRate));
                    }
                    return base * taxOp(Number(otherTax), Number(tax)) - base * (1 + Number(otherTax));
                }
            } else {
                var _loop = function(order) {
                    var rules = _.filter(orderedTaxRules, function(rule) {
                        return rule.order === order && rule.stage.op === 'add';
                    });
                    var orderTax = Big(0);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // eslint-disable-next-line no-restricted-syntax
                        for(var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var rule = _step.value;
                            var thisTax = void 0;
                            if (rule.taxBasis === 'wholesale') {
                                var nonArmsLength = productData === null || productData === void 0 ? void 0 : productData.nonArmsLength;
                                if (!nonArmsLength && wPrice !== undefined) {
                                    thisTax = wPrice.times(rule.rate);
                                } else {
                                    thisTax = currentTaxBasis.times(rule.rate);
                                }
                            } else {
                                var potency = rule.potency, potencyRate = rule.potencyRate, destinationRate = rule.destinationRate;
                                var effectiveRate = isDelivery && _.isFinite(destinationRate) ? destinationRate : rule.rate;
                                // if we have potency & thcContent, but the operand formed is false, do not include
                                // that rule's rate in the total tax rate.
                                var thcValueDoesntMatchRule = potency && thcContent && !operandMap[potency](thcContent, potencyRate * 100);
                                // if we have potency but no thcContent, then exclude all but rules with 'greater'
                                var noThc = potency && !thcContent;
                                var largestPotencyRule = _.includes(potency, 'greater');
                                if (thcValueDoesntMatchRule || noThc && !largestPotencyRule) {
                                    effectiveRate = Big(0);
                                }
                                thisTax = currentTaxBasis.times(effectiveRate);
                            }
                            orderTax = orderTax.plus(thisTax);
                            totalTax[rule.taxType] = totalTax[rule.taxType].plus(thisTax);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    currentTaxBasis = currentTaxBasis.plus(orderTax);
                };
                var __maxBy;
                var currentTaxBasis = Big(base);
                var totalTax = {
                    sales: Big(0),
                    cannabis: Big(0),
                    bottleDeposit: Big(0)
                };
                var filteredRules = relevantTaxRules(category, hemp, type, taxRules, null);
                filteredRules = _.filter(filteredRules, function(rule) {
                    return rule.stage.op !== 'noop';
                });
                var groupedRules = _.groupBy(filteredRules, 'id');
                var filteredGroupedRules = _.reduce(groupedRules, function(accum, value, key) {
                    var minuses = _.filter(value, function(val) {
                        return val.stage.op === 'subtract';
                    }).length;
                    if (minuses !== 0) {
                        var adds = _.filter(value, function(val) {
                            return val.stage.op === 'add';
                        }).length;
                        // We can fix up this situation.  If there are more subtracts we're bailing.
                        if (adds > minuses) {
                            value = _.filter(value, function(val) {
                                return val.stage.op !== 'subtract';
                            });
                            value = value.slice(0, adds - minuses);
                        }
                    }
                    accum[key] = value;
                    return accum;
                }, {});
                var flattenedRules = _.flatMap(_.values(filteredGroupedRules), function(val) {
                    return val;
                });
                // If there isn't an order enforce one where the cannabis taxes are before the sales taxes.
                // This should be a fairly uncommon configuration these days.
                var orderedTaxRules = _.map(flattenedRules, function(rule) {
                    return _object_spread_props(_object_spread({}, rule), {
                        order: rule.order || (rule.taxType === 'cannabis' ? 0 : 1)
                    });
                });
                var maxOrder = ((__maxBy = _.maxBy(orderedTaxRules, 'order')) === null || __maxBy === void 0 ? void 0 : __maxBy.order) || 0;
                for(var order = 0; order <= maxOrder; order++)_loop(order);
                return totalTax[taxType];
            }
            return undefined;
        };
    };
    var isCannabisTax = cannabisRate.gt(cannabisPreRate) || wholesaleCannabisTaxRate.gt(0);
    var isSalesTax = salesRate.gt(salesPreRate);
    if (isOrdered) {
        taxMult = orderedTaxesMult(orderedRules);
    }
    return {
        bottleDepositTaxCents: bottleDepositTaxCents,
        cannabisTax: isCannabisTax ? makeCalcTax(salesRate, cannabisRate, 'cannabis') : returnZero,
        salesTax: isSalesTax ? makeCalcTax(cannabisRate, salesRate, 'sales') : returnZero,
        basePrice: basePriceCalc(salesPreRate, cannabisPreRate, bottleDepositPreSum),
        taxMult: taxMult
    };
};
/*
 * This returns true if the dispensary has discounts before taxes but any tax
 * data in their data by the menu.
 */ var oddDiscountTreatment = function(dispensary) {
    if (dispensary.taxConfig.discountTaxOrder !== 'discountsFirst' && dispensary.taxConfig.discountTaxOrder !== 'both') {
        return false;
    }
    var rules = flattenTaxes(dispensary.taxConfig).filter(function(rule) {
        return rule.stage.type !== 'checkout' && rule.stage.op !== 'noop';
    });
    var numAdds = rules.filter(function(rule) {
        return rule.stage.op === 'add';
    }).length;
    var numSubs = rules.filter(function(rule) {
        return rule.stage.op === 'subtract';
    }).length;
    return numAdds - numSubs > 0;
};
var originBasedTaxStates = [
    'AZ',
    'CA',
    'IL',
    'MS',
    'MO',
    'NM',
    'OH',
    'PA',
    'TN',
    'TX',
    'UT',
    'VA'
];
var getDefaultSalesTaxDeliveryPolicy = function(state) {
    return originBasedTaxStates.includes(state) ? 'originBased' : 'destinationBased';
};
export { calcTaxes, getDefaultSalesTaxDeliveryPolicy, flattenTaxes, layerOrder, oddDiscountTreatment, relevantTaxRules, roundTo, sumTaxesAtLayer };
